import  * as RDSConstants from './RDSConstants';
// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require('object.assign');


// The initial application state
const initialState = {
    
    isFetching : false,
    isFetched : false,
    searchResult : [],
    islaunched:false,
    isLuancherror:false,
    isFileShareClicked: false,
    isRDSClicked: false
};
var stateSearchResults = [];
// Takes care of changing the application state
export default function RDSReducer (state = initialState, action) {
    switch (action.type) {

        case RDSConstants.LAUNCH_RDS_REQUEST:
            return assign({}, state, {
                    isFetching : true,
                    isFetched : false,
                    searchRDSResult : [],
                    islaunched:false,
                    isLuancherror:false
                });
            break;
        case RDSConstants.LAUNCH_RDS_SUCCESS:
           {
             

                return assign({},state,{
                    isFetching : false,
                    isFetched : true,
                    searchRDSResult : action.newState.result ,
                    islaunched:true,
                    isLuancherror:false                     
                });
            }
            
            break;
            case RDSConstants.LAUNCH_RDS_FAILURE:
            {     let msgSTR= (action.newState && action.newState && action.newState.responseJson)?
                              action.newState.responseJson.message :RDSConstants.RDS_GENERIC_MESSAGE;
                 
                    return assign({}, state, {
                    
                    isFetching : false,
                    isFetched : true,
                    islaunched:false,
                    isLuanchError:true,
                    LuanchErrorMessage:msgSTR
                    });
               
        }
    
             break;
            // VERIFY RDS 


            case RDSConstants.RDS_CHECK_REQUEST:
            return assign({}, state, {
                    isVerfiyRDSFetching : true,
                    isRDSFetched : false,
                    searchResult : [],
                    isconnected:false,
                    sessionExist:false,
                    isLuanchError:false
                });
            break;
       
            case RDSConstants.RDS_CHECK_SUCCESS:
           {
               console.log('Suucess inside reducer for VerifyRDS');
                
               return assign({},state,{
                    isVerfiyRDSFetching : false,
                    isRDSFetched : true,
                    //searchResult : action.newState.result ,
                    //islaunched:true  ,
                    isconnected:true,
                    sessionExist:false,
                    isLuanchError:false                  
                });
            }
            
        break;
        case RDSConstants.RDS_CHECK_FAILURE:
        { 
           var msgSTR= '';
          
           var myobj;
          if (action.newState && action.newState.status == 403) {
            msgSTR= 'You do not have access to the application feature.  Please contact DxS IntelliServe support team to request access'
          }
          else if(action.newState && action.newState.responseText)
           {  myobj = JSON.parse(action.newState.responseText)
              msgSTR= myobj.message
           }
           else
            {
              msgSTR = 'RDS session cannot be established due to technical error, please contact DxS IntelliServe support.'
            }
            console.log('msgSTR is >>> '+msgSTR);
       
            return assign({}, state, {
                isVerfiyRDSFetching : false,
                isRDSFetched : true,
                //islaunched:false
                isconnected:false,
                sessionExist:msgSTR,
                isLuanchError:false
            });
            }
            break;
            case RDSConstants.LAUNCH_RDS_PROMPT:
            {  return assign({}, state, {
                        isFetching : false,
                        isFetched : true,
                        isLaunched : false
                    });
                }
            break;
        case RDSConstants.SET_RDS_ACTION: {
            return assign({}, state, {
                isRDSClicked : true,
                isFileShareClicked : false
            });
        }
        break;
        case RDSConstants.SET_FILESHARE_ACTION: {
            return assign({}, state, {
                isFileShareClicked : true,
                isRDSClicked : false
            });
        }
        break;
        case RDSConstants.RESET_FILESHARE_RDS_ACTION: {
            return assign({}, state, {
                isFileShareClicked : false,
                isRDSClicked: false
        });
        }
        break;       
        default:
            return state;
    }
}